import Image from 'global/Image';
import PropTypes from 'prop-types';
import uploadImageUtils from 'utils/uploadImage';

const SmallAvatar = ({
  avatar: avatarProps,
  username = null,
  avatar_override: avatarOverRide,
  custom,
  overlayClassName,
  state,
  onAvatarError,
  handleImageOnLoad,
  avatarURL,
}) => {
  const { avatarDiv, avatarClass } = state;
  let image;

  if (avatarProps) {
    if (avatarProps.match(/\bhttp/i)) {
      image = avatarProps;
    } else {
      image = `${avatarURL}/${avatarProps}`;
    }
  } else {
    image = null;
  }

  let avatar = image;

  let lastslashurl = '';
  if (image) lastslashurl = uploadImageUtils.lastSlashURL(avatar);

  let imageDiv;

  if (
    !lastslashurl ||
    lastslashurl.includes('noimage') ||
    lastslashurl === '0'
  ) {
    imageDiv = username ? username.charAt(0).toUpperCase() : '';
  } else {
    if (avatarOverRide) avatar = avatarProps;

    imageDiv = (
      <Image
        alt="avatar"
        className={`${avatarClass} ${overlayClassName}`}
        src={avatar}
        onError={onAvatarError}
        onLoad={handleImageOnLoad}
      />
    );
  }

  imageDiv = avatarDiv || imageDiv;

  // Add custom props for avatar notification, tipping, trending => for removing img border
  if (custom === 'tipping' || custom === 'trending') return imageDiv;

  return <i data-username={username}>{imageDiv}</i>;
};

SmallAvatar.propTypes = {
  avatar: PropTypes.string,
  username: PropTypes.string,
  avatar_override: PropTypes.string,
  custom: PropTypes.string,
  overlayClassName: PropTypes.string,
  state: PropTypes.shape({
    avatarDiv: PropTypes.string,
    avatarClass: PropTypes.string,
  }),
  onAvatarError: PropTypes.func,
  handleImageOnLoad: PropTypes.func,
  avatarURL: PropTypes.string.isRequired,
};

SmallAvatar.defaultProps = {
  avatar: '',
  username: '',
  avatar_override: '',
  custom: '',
  overlayClassName: '',
  state: {
    avatarDiv: null,
    avatarClass: '',
  },
  onAvatarError: () => {},
  handleImageOnLoad: () => {},
};

export default SmallAvatar;
